module.exports = __webpack_public_path__ + "static/media/BackProgress.3306ff97.svg";